import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import clientBrainMemoryIt from './locales/clientBrainMemory/it.json';
import clientBrainMemoryEn from './locales/clientBrainMemory/en.json';
import clientBrainMemoryEs from './locales/clientBrainMemory/es.json';
import clientBrainMemoryFr from './locales/clientBrainMemory/fr.json';
import carouselRenderIt from './locales/carouselRender/it.json';
import carouselRenderEn from './locales/carouselRender/en.json';
import carouselRenderEs from './locales/carouselRender/es.json';
import carouselRenderFr from './locales/carouselRender/fr.json';
import funnyLandingIt from './locales/funnyLanding/it.json';
import funnyLandingEn from './locales/funnyLanding/en.json';
import funnyLandingEs from './locales/funnyLanding/es.json';
import funnyLandingFr from './locales/funnyLanding/fr.json';

const withFeatureLocales = (base, clientBrainMemory, carouselRender, funnyLanding) => ({
  ...base,
  funnyLanding,
  editor: {
    ...base.editor,
    ...carouselRender,
  },
  project: {
    ...base.project,
    clientBrainMemory,
  },
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: withFeatureLocales(it, clientBrainMemoryIt, carouselRenderIt, funnyLandingIt) },
      en: { translation: withFeatureLocales(en, clientBrainMemoryEn, carouselRenderEn, funnyLandingEn) },
      es: { translation: withFeatureLocales(es, clientBrainMemoryEs, carouselRenderEs, funnyLandingEs) },
      fr: { translation: withFeatureLocales(fr, clientBrainMemoryFr, carouselRenderFr, funnyLandingFr) },
    },
    fallbackLng: 'it',
    supportedLngs: ['it', 'en', 'es', 'fr'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'sketchario_lang',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
